import withLazyAndSuspense from '../../utils/lazy';
const ribuk = withLazyAndSuspense(() =>
  import('../../../src/Products/RIB-UK/ribUk'),
);

const directDebitSetup = withLazyAndSuspense(() =>
  import(
    '../../../src/Products/RIB-UK/services/directDebitSetup/directDebitSetup'
  ),
);

const smsAlertorDereg = withLazyAndSuspense(() =>
  import(
    '../../../src/Products/RIB-UK//services/smsAlertorDereg/smsAlertorDereg'
  ),
);

const GIRO = withLazyAndSuspense(() =>
  import('../../../src/Products/RIB-UK/services/GIRO/GIRO'),
);

const reuseDebitCard = withLazyAndSuspense(() =>
  import(
    '../../../src/Products/RIB-UK/services/resuseDebitCard/reuseDebitCard'
  ),
);

const reuseDebitCardDetails = withLazyAndSuspense(() =>
  import('../../../src/Products/RIB-UK/services/reissueDebit/reissueDebit'),
);

const tracServiceRequest = withLazyAndSuspense(() =>
  import(
    '../../../src/Products/RIB-UK/services/tracServiceRequest/tracServiceRequest'
  ),
);

const statement = withLazyAndSuspense(() =>
  import('../../../src/Products/RIB-UK/services/statement/statement'),
);

const changeEMailorNumber = withLazyAndSuspense(() =>
  import(
    '../../../src/Products/RIB-UK/services/changeEMailorNumber/changeEMailorNumber'
  ),
);

const chequeBookInsurance = withLazyAndSuspense(() =>
  import(
    '../../../src/Products/RIB-UK/services/chequeBookInsurance/chequeBookInsurance'
  ),
);

const ErrorScreen = withLazyAndSuspense(() =>
  import('../../../src/Products/RIB-UK/shared/containers/erroScreen'),
);

const CommonRouteMapRibuk = {
  ribuk: {
    component: ribuk,
    path: `/servicing/instantServicesUk`,
  },
  directDebitSetup: {
    component: directDebitSetup,
    path: `/servicing/ribuk-services/directDebitSetup`,
  },
  smsAlertorDereg: {
    component: smsAlertorDereg,
    path: `/servicing/ribuk-services/smsAlertorDereg`,
  },
  GIRO: {
    component: GIRO,
    path: `/servicing/ribuk-services/GIRO`,
  },
  reuseDebitCard: {
    component: reuseDebitCard,
    path: `/servicing/ribuk-services/reissueDebitPin`,
  },
  tracServiceRequest: {
    component: tracServiceRequest,
    path: `/servicing/ribuk-services/tracServiceRequest`,
  },
  statement: {
    component: statement,
    path: `/servicing/ribuk-services/statement`,
  },
  changeEMailorNumber: {
    component: changeEMailorNumber,
    path: `/servicing/ribuk-services/changeEMailorNumber`,
  },
  chequeBookInsurance: {
    component: chequeBookInsurance,
    path: `/servicing/ribuk-services/chequeBookInsurance`,
  },
  reuseDebitCardDetails: {
    component: reuseDebitCardDetails,
    path: `/servicing/ribuk-services/reissueDebitCard`,
  },
  ErrorScreen: {
    component: ErrorScreen,
    path: `/servicing/ribukError`,
  },
};
export default CommonRouteMapRibuk;

//RIBUK Path Shortcuts
// ribuk : `/servicing/instantServicesUk`,
// directDebitSetup : `/servicing/ribuk-services/directDebitSetup`,
// smsAlertorDereg :`/servicing/ribuk-services/smsAlertorDereg`,
// GIRO :`/servicing/ribuk-services/GIRO`,
// reuseDebitCard : `/servicing/ribuk-services/reissueDebitPin`,
// tracServiceRequest : `/servicing/ribuk-services/tracServiceRequest`,
// statement : `/servicing/ribuk-services/statement`,
// changeEMailorNumber :`/servicing/ribuk-services/changeEMailorNumber`,
// chequeBookInsurance :`/servicing/ribuk-services/chequeBookInsurance`,
// reuseDebitCardDetails :`/servicing/ribuk-services/reissueDebitCard`,
